(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-video-display"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lara11-video-player')) {
    customElements.define('lara11-video-player', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;

        this.video = this.querySelector('video');
        this.controls = this.querySelector('[data-player-controls]');
        this.timeline = this.querySelector('[data-player-timeline]');
        this.playButton = this.querySelector('[data-player-play]');
        this.playIcon = this.querySelector('[data-player-play-icon]');
        this.muteButton = this.querySelector('[data-player-mute]');
        this.volumeIcon = this.querySelector('[data-player-volume-icon]');
        this.volume = this.querySelector('[data-player-volume]');
        this.volumeGroup = this.querySelector('[data-player-volume-group]');

        if (!this.video || !this.controls || !this.timeline || !this.playButton || !this.playIcon || !this.muteButton || !this.volumeIcon || !this.volume || !this.volumeGroup) return;

        this.abortController = new AbortController();
        this.lastVolume = this.video.volume || 1;
        this.lastPointerType = '';
        this.video.controls = false;
        this.video.removeAttribute('controls');
        this.dataset.ready = 'true';

        const signal = this.abortController.signal;
        this.playButton.addEventListener('click', () => this.togglePlay(), { signal });
        this.muteButton.addEventListener('pointerup', (event) => { this.lastPointerType = event.pointerType; }, { signal });
        this.muteButton.addEventListener('click', () => this.toggleMute(), { signal });
        this.timeline.addEventListener('input', () => this.seek(), { signal });
        this.volume.addEventListener('input', () => this.changeVolume(), { signal });
        this.video.addEventListener('play', () => this.updatePlaybackState(), { signal });
        this.video.addEventListener('pause', () => this.updatePlaybackState(), { signal });
        this.video.addEventListener('ended', () => this.updatePlaybackState(), { signal });
        this.video.addEventListener('timeupdate', () => this.updateTimeline(), { signal });
        this.video.addEventListener('progress', () => this.updateBuffer(), { signal });
        this.video.addEventListener('loadedmetadata', () => {
          this.updateTimeline();
          this.updateBuffer();
        }, { signal });
        this.video.addEventListener('durationchange', () => this.updateTimeline(), { signal });
        this.video.addEventListener('volumechange', () => this.updateVolume(), { signal });
        this.video.addEventListener('pointerup', (event) => this.handleVideoPointer(event), { signal });
        this.video.addEventListener('keydown', (event) => this.handleVideoKeydown(event), { signal });
        this.addEventListener('pointermove', (event) => {
          if (event.pointerType === 'mouse') this.showControls(1200);
        }, { signal });
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse' && !this.video.paused) this.hideControls();
        }, { signal });
        this.controls.addEventListener('pointerdown', () => window.clearTimeout(this.hideTimer), { signal });
        this.controls.addEventListener('pointerup', () => this.showControls(2000), { signal });

        this.updatePlaybackState();
        this.updateTimeline();
        this.updateBuffer();
        this.updateVolume();
      }

      togglePlay() {
        if (this.video.paused || this.video.ended) {
          const playPromise = this.video.play();
          if (playPromise) playPromise.catch(() => this.showControls(2000));
        } else {
          this.video.pause();
        }
      }

      updatePlaybackState() {
        const isPaused = this.video.paused || this.video.ended;
        this.classList.toggle('paused', isPaused);
        this.playIcon.setAttribute('d', isPaused ? 'M8 5v14l11-7z' : 'M6 19h4V5H6v14zm8-14v14h4V5h-4z');
        this.playButton.setAttribute('aria-label', isPaused ? this.dataset.playLabel : this.dataset.pauseLabel);

        if (isPaused) {
          window.clearTimeout(this.hideTimer);
          this.classList.remove('active');
        } else {
          this.showControls(1000);
        }
      }

      handleVideoPointer(event) {
        if (event.pointerType === 'touch' && !this.classList.contains('active') && !this.video.paused) {
          this.showControls(2000);
          return;
        }

        this.togglePlay();
      }

      handleVideoKeydown(event) {
        if (event.key !== ' ' && event.key.toLowerCase() !== 'k') return;
        event.preventDefault();
        this.togglePlay();
      }

      showControls(delay = 1200) {
        this.classList.add('active');
        window.clearTimeout(this.hideTimer);

        if (!this.video.paused) {
          this.hideTimer = window.setTimeout(() => {
            if (this.matches(':focus-within')) return;
            this.classList.remove('active');
            this.volumeGroup.classList.remove('open');
          }, delay);
        }
      }

      hideControls() {
        window.clearTimeout(this.hideTimer);
        this.classList.remove('active');
        this.volumeGroup.classList.remove('open');
      }

      updateTimeline() {
        if (!Number.isFinite(this.video.duration) || this.video.duration <= 0) return;
        const percentage = Math.min(100, Math.max(0, (this.video.currentTime / this.video.duration) * 100));
        this.timeline.value = percentage;
        this.timeline.style.setProperty('--player-progress', `${percentage}%`);
        this.timeline.setAttribute('aria-valuetext', `${this.formatTime(this.video.currentTime)} / ${this.formatTime(this.video.duration)}`);
      }

      seek() {
        if (!Number.isFinite(this.video.duration) || this.video.duration <= 0) return;
        const percentage = Number(this.timeline.value);
        this.video.currentTime = (percentage / 100) * this.video.duration;
        this.timeline.style.setProperty('--player-progress', `${percentage}%`);
        this.updateBuffer();
      }

      updateBuffer() {
        if (!Number.isFinite(this.video.duration) || this.video.duration <= 0 || this.video.buffered.length === 0) return;
        let bufferedEnd = 0;

        for (let index = 0; index < this.video.buffered.length; index += 1) {
          if (this.video.buffered.start(index) <= this.video.currentTime && this.video.buffered.end(index) >= this.video.currentTime) {
            bufferedEnd = this.video.buffered.end(index);
            break;
          }
        }

        if (!bufferedEnd) bufferedEnd = this.video.buffered.end(this.video.buffered.length - 1);
        this.timeline.style.setProperty('--player-buffer', `${Math.min(100, (bufferedEnd / this.video.duration) * 100)}%`);
      }

      toggleMute() {
        if (this.lastPointerType === 'touch' && !this.volumeGroup.classList.contains('open')) {
          this.volumeGroup.classList.add('open');
          this.lastPointerType = '';
          this.showControls(2000);
          return;
        }

        this.lastPointerType = '';

        if (this.video.muted || this.video.volume === 0) {
          this.video.muted = false;
          if (this.video.volume === 0) this.video.volume = this.lastVolume || 0.5;
        } else {
          this.lastVolume = this.video.volume;
          this.video.muted = true;
        }
      }

      changeVolume() {
        const nextVolume = Math.min(1, Math.max(0, Number(this.volume.value)));
        this.video.volume = nextVolume;
        this.video.muted = nextVolume === 0;
        if (nextVolume > 0) this.lastVolume = nextVolume;
      }

      updateVolume() {
        const value = this.video.muted ? 0 : this.video.volume;
        this.volume.value = value;
        this.volume.style.setProperty('--player-volume', `${value * 100}%`);
        this.volumeIcon.setAttribute('d', value === 0
          ? 'M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z'
          : 'M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z');
        this.muteButton.setAttribute('aria-label', value === 0 ? this.dataset.unmuteLabel : this.dataset.muteLabel);
      }

      formatTime(seconds) {
        const value = Math.max(0, Math.floor(Number(seconds) || 0));
        const minutes = Math.floor(value / 60);
        return `${minutes}:${String(value % 60).padStart(2, '0')}`;
      }

      disconnectedCallback() {
        window.clearTimeout(this.hideTimer);
        if (this.abortController) this.abortController.abort();
        this.abortController = null;
      }
    });
  }

  if (!customElements.get('lara-dynamic-video-display')) {
    customElements.define('lara-dynamic-video-display', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.hideWhenStacked !== 'true') return;
        this.frame = requestAnimationFrame(() => this.start());
      }

      start() {
        if (!this.isConnected) return;
        this.layout = this.querySelector('.dvd__layout');
        this.media = this.querySelector('.dvd__media');
        if (!this.layout || !this.media || !this.querySelector('.dvd__content')) return;

        this.scheduleUpdate = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateLayout());
        };

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.scheduleUpdate);
          this.observer.observe(this.layout);
          this.observer.observe(this.media);
        }
        window.addEventListener('resize', this.scheduleUpdate, { passive: true });
        this.updateLayout();
      }

      updateLayout() {
        if (!this.isConnected) return;
        const layoutStyle = getComputedStyle(this.layout);
        const availableWidth = parseFloat(layoutStyle.width);
        const mediaWidth = parseFloat(getComputedStyle(this.media).width);
        const textMinimum = parseFloat(getComputedStyle(this).getPropertyValue('--dvd-text-min')) || 320;
        const gap = parseFloat(layoutStyle.columnGap) || 0;

        if (!(availableWidth > 0) || !Number.isFinite(mediaWidth)) return;

        // Media sizing does not grow to fill the space released by hidden text.
        // We test the space the text WOULD need, even while it is display:none.
        // This avoids alternating visible/hidden states on each measurement.
        const fits = availableWidth + 0.01 >= mediaWidth + gap + textMinimum;
        const nextLayout = fits ? 'row' : 'stacked';
        if (this.dataset.layout !== nextLayout) this.dataset.layout = nextLayout;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.observer) this.observer.disconnect();
        if (this.scheduleUpdate) window.removeEventListener('resize', this.scheduleUpdate);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
